module.exports = __webpack_public_path__ + "static/media/fed-elec-social-image-min.1fd9c764.png";